import type { UserDotComCivchat } from "./userDotCom.types";

type WidgetCommand = "widget.show" | "widget.hide";

const mode = { onDemand: false };

const run = (command: WidgetCommand) => {
  window.userengage?.(command);
};

export const createCivchatConfig = (apiKey: string): UserDotComCivchat => ({
  apiKey,
  onLoad: () => {
    if (mode.onDemand) run("widget.hide");
  },
  onClose: () => {
    if (mode.onDemand) run("widget.hide");
  },
  onMessage: message => {
    if (message?.isAdmin) run("widget.show");
  },
});

export const keepSupportChatOnDemand = () => {
  mode.onDemand = true;
  run("widget.hide");
  return () => {
    mode.onDemand = false;
    run("widget.show");
  };
};
